import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientRisksPage from "@/pages/client/ClientRisksPage";

export const Route = createFileRoute("/client/risks")({
  head: () => pageHead("Client · Risks", "AKIVA client · risks portal.", "/client/risks", true),
  component: ClientRisksPage,
});
